module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDI0IDIwIj4KICAgIDxnIGZpbGw9IiM0MTQwM0UiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPHBhdGggZmlsbC1ydWxlPSJub256ZXJvIiBkPSJNMTAuODE1IDEzbDEuMTIgMkgwdi0yaDJWMS44NzVDMiAuODM5IDIuODE0IDAgMy44MTggMGgxNi4zNjRDMjEuMTg2IDAgMjIgLjg0IDIyIDEuODc1VjEzaDJ2MmgtNC4zNWwtMS4zOC0ySDIwVjJINHYxMWg2LjgxNXoiLz4KICAgICAgICA8cGF0aCBkPSJNOC4zODUgNC41NjFsMS42Mi0uOTczIDkuMjU4IDE0LjI3LTIuNTcxIDEuNTQ1eiIvPgogICAgPC9nPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/menubar/icon-classroom.svg
// module id = pquC
// module chunks = 18